
import { CalculatorTranslations } from "./types";

export const CALCULATOR_CONTENT: CalculatorTranslations = {
  fr: {
    title: "Calculateur d'investissement depuis la naissance",
    subtitle: "Quel enjeu ?",
    example: "Prenons votre exemple",
    bornIn: "Vous êtes né en",
    giftsReceived: "Cadeaux qui vous ont été offerts",
    investmentPart: "Part qui auraient pu être investie",
    yourCapital: "Votre capital",
    giftValue: "Valeur des jouets",
    livretA: "Livret A (1,5%)",
    legatia: "Legatia ETF (8%)",
    at18: "À 18 ans",
    at25: "À 25 ans", 
    at30: "À 30 ans",
    now: "Maintenant",
    startInvesting: "Commencer à investir maintenant"
  },
  en: {
    title: "Investment calculator from birth",
    subtitle: "What's at stake?",
    example: "Let's take your example",
    bornIn: "You were born in",
    giftsReceived: "Gifts that were given to you",
    investmentPart: "Part that could have been invested",
    yourCapital: "Your capital",
    giftValue: "Toy value",
    livretA: "Livret A (1.5%)",
    legatia: "Legatia ETF (8%)",
    at18: "At 18",
    at25: "At 25",
    at30: "At 30",
    now: "Now",
    startInvesting: "Start investing now"
  },
  de: {
    title: "Investitionsrechner ab Geburt",
    subtitle: "Was steht auf dem Spiel?",
    example: "Nehmen wir Ihr Beispiel",
    bornIn: "Sie wurden geboren in",
    giftsReceived: "Geschenke, die Ihnen gegeben wurden",
    investmentPart: "Teil, der hätte investiert werden können",
    yourCapital: "Ihr Kapital",
    giftValue: "Spielzeugwert",
    livretA: "Livret A (1,5%)",
    legatia: "Legatia ETF (8%)",
    at18: "Mit 18",
    at25: "Mit 25",
    at30: "Mit 30",
    now: "Jetzt",
    startInvesting: "Jetzt mit dem Investieren beginnen"
  }
};
